<template>
  <ul class="filter-pills">
    <li
      v-for="searchTerm in searchStore.flatSearchResults"
      :key="searchTerm.slug"
      class="filter-pills__item"
      :class="{ 'filter-pills__item--is-sale': 'sale' === searchTerm.type }"
      @click="searchStore.removeFilter(searchTerm)">
      <icon-vendors
        v-if="'vendor' === searchTerm.type"
        class="filter-pills__type-icon" />
      <icon-categories
        v-else-if="['categories', 'urlCategories'].includes(searchTerm.type)"
        class="filter-pills__type-icon" />
      <icon-tags
        v-else-if="['tags', 'urlTags'].includes(searchTerm.type)"
        class="filter-pills__type-icon" />
      <icon-magnifying-lens
        v-else-if="'freeText' === searchTerm.type"
        class="filter-pills__type-icon" />
      <span v-if="searchTerm.type === 'freeText'" v-text="searchTerm.name" />
      <span v-else-if="searchTerm.name" v-html="searchTerm.name" />
      <button class="filter-pills__remove" @click.stop="searchStore.removeFilter(searchTerm)">
        <icon-close />
      </button>
    </li>
    <li v-if="searchStore.flatSearchResults.length > 1">
      <button class="filter-pills__remove-all" @click="searchStore.removeAllFilters()">
        Remove all filters
      </button>
    </li>
  </ul>
</template>

<script setup lang="ts">
import { useSearchStore } from "~/stores/searchStore";
import IconClose from "assets/icons/IconClose.svg";
import { defineAsyncComponent } from "#imports";

const IconVendors = defineAsyncComponent(() => import('~/assets/icons/IconVendors.svg'));
const IconCategories = defineAsyncComponent(() => import('~/assets/icons/IconCategories.svg'));
const IconTags = defineAsyncComponent(() => import('~/assets/icons/IconTags.svg'));
const IconMagnifyingLens = defineAsyncComponent(() => import('~/assets/icons/IconMagnifyingLens.svg'));
const searchStore = useSearchStore();
</script>

<style lang="scss">
@use "~/common/scss/button";
@use "~/common/scss/helpers";
@use "~/common/scss/variables";

.filter-pills {
  align-items: center;
  display: flex;
  flex-flow: row wrap;
  gap: .25rem .5rem;
  list-style: none;
  padding: 0 0;

  &__item {
    align-items: center;
    background-color: #FFFFFF;
    border-radius: helpers.px-to-rem(100);
    border: 1px solid #000000;
    display: flex;
    gap: helpers.px-to-rem(6);
    min-height: helpers.px-to-rem(30);
    justify-content: space-between;
    min-width: helpers.px-to-rem(80);
    padding: .1rem helpers.px-to-rem(5) .1rem helpers.px-to-rem(12);

    &--is-sale {
      background-color: #EFCEB6;
    }
  }

  &__type-icon {
    font-size: helpers.px-to-rem(14);
  }

  &__remove {
    display: flex;
    font-size: helpers.px-to-rem(20);
    height: helpers.px-to-rem(20);
    transition: color .25s;
    width: helpers.px-to-rem(20);

    &:hover,
    &:focus,
    &:active {
      color: variables.$colorRed;
    }
  }

  &__remove-all {
    @include button.buttonSmall(true);
    @include button.buttonRedText();

    margin-left: auto;
  }
}
</style>
